import mapActions from './mapActions';

export default mapActions('unlocked_employees', {
    fetchAll_url: data => `/api/working_hours/list/${data.year}/${data.month}`
});